var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.root},[(_vm.src)?_c('iframe',_vm._b({attrs:{"src":_vm.src,"frameborder":"0"},on:{"load":function($event){return _vm.onLoad($event)}}},'iframe',_vm.$attrs,false)):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }